module.exports = __webpack_public_path__ + "static/media/7.5.b3612991.png";